import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/svg/mobile/shevron-left.svg'
import _imports_1 from '@/assets/svg/icon_time.svg'
import _imports_2 from '@/assets/svg/icon_nearby.svg'
import _imports_3 from '@/assets/svg/icon_location.svg'


const _withScopeId = n => (_pushScopeId("data-v-10e4db7e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mt-[130px]" }
const _hoisted_2 = { class: "grid grid-cols-[22px_auto] items-center gap-x-3 mb-[60px] px-6" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "flex flex-col" }
const _hoisted_6 = { class: "px-6 mb-[60px]" }
const _hoisted_7 = { class: "h-[272px] w-full bg-[var(--primary-color)] relative" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "px-10 mb-[60px]" }
const _hoisted_10 = { class: "reservation" }
const _hoisted_11 = { class: "flex flex-col gap-y-3" }
const _hoisted_12 = {
  key: 0,
  class: "fixed inset-0 z-30"
}
const _hoisted_13 = { class: "flex gap-x-4 px-3" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "w-[27px]"
}, null, -1))
const _hoisted_15 = { class: "flex gap-x-4 px-3" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "w-[27px]"
}, null, -1))
const _hoisted_17 = { class: "flex gap-x-4 px-3" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "w-[27px]"
}, null, -1))
const _hoisted_19 = { class: "px-6 mb-[60px]" }
const _hoisted_20 = { class: "flex flex-col items-center gap-y-6" }
const _hoisted_21 = { class: "px-3" }
const _hoisted_22 = { class: "p-[10px] text-[14px]" }
const _hoisted_23 = {
  key: 0,
  class: "absolute inset-0 flex items-center justify-center"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Загрузка...", -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = { class: "mb-[60px] px-10" }
const _hoisted_27 = { class: "p-3 mb-6" }
const _hoisted_28 = { class: "mb-[60px] px-10" }
const _hoisted_29 = { class: "p-3 mb-6" }
const _hoisted_30 = { class: "pl-5 mt-4" }
const _hoisted_31 = { class: "list-disc pl-10 mt-4" }
const _hoisted_32 = { class: "pl-5 mt-4" }
const _hoisted_33 = { class: "mb-6" }
const _hoisted_34 = { class: "pl-5 mt-4" }
const _hoisted_35 = { class: "mb-6" }

import { ref } from 'vue';
import { useRouter } from 'vue-router';
import BaseAccordion from '@/components/common/BaseAccordion.vue';
import BaseTypography from '@/components/common/BaseTypography.vue';
import BaseLine from '@/components/common/BaseLine.vue';
import BaseButton from '@/components/common/BaseButton.vue';
import ExcursionForm from './ExcursionForm.vue';
import MarkdownRenderer from '@/components/common/MarkdownRenderer.vue';
import { useGlobalStore } from '@/stores/global';


export default /*#__PURE__*/_defineComponent({
  __name: 'ExcursionMobile',
  props: {
    id: {}
  },
  setup(__props: any) {

const props = __props;

const strapiUrl = process.env.VUE_APP_STRAPI_URL;

const router = useRouter();
const globalStore = useGlobalStore();
const { getExcursion } = globalStore;

const toggle = ref<boolean>(false);
const excursion = ref<any>();
const isLoading = ref<boolean>(true);

const toggleForm = () => (toggle.value = !toggle.value);

const onLoad = async () => {
    isLoading.value = true;
    excursion.value = await getExcursion(props.id);
    isLoading.value = false;
};

onLoad();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).back()))
      }, _hoisted_4),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(BaseTypography, {
          text: excursion.value?.data?.attributes.title,
          type: "subtitle-m",
          color: "var(--primary-color)",
          class: "mb-3"
        }, null, 8, ["text"]),
        _createVNode(BaseLine, { width: "299" })
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("img", {
          src: `${_unref(strapiUrl)}${excursion.value?.data.attributes.img.data.attributes.url}`,
          class: "absolute top-0 w-full"
        }, null, 8, _hoisted_8)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", null, [
            _createVNode(BaseTypography, {
              text: excursion.value?.data?.attributes.summForGroup.toString(),
              type: "subtitle-m",
              color: "var(--secondary-color)",
              tag: "span"
            }, null, 8, ["text"]),
            _createVNode(BaseTypography, {
              text: " ₽/чел",
              type: "body2-m",
              tag: "span"
            }),
            _createVNode(BaseTypography, {
              text: excursion.value?.data?.attributes.group,
              type: "body-m"
            }, null, 8, ["text"])
          ]),
          _createElementVNode("div", null, [
            _createVNode(BaseTypography, {
              text: excursion.value?.data?.attributes.summForInd.toString(),
              type: "subtitle-m",
              color: "var(--secondary-color)",
              tag: "span"
            }, null, 8, ["text"]),
            _createVNode(BaseTypography, {
              text: " ₽/чел",
              type: "body2-m",
              tag: "span"
            }),
            _createVNode(BaseTypography, {
              text: excursion.value?.data?.attributes.excursionType,
              type: "body-m"
            }, null, 8, ["text"])
          ])
        ]),
        _createVNode(BaseButton, {
          text: "Забронировать",
          "padding-y": "18",
          "padding-x": "67",
          type: "subtitle4-m",
          color: "var(--base-white)",
          ui: "green",
          onClick: toggleForm
        }),
        (toggle.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createVNode(ExcursionForm, { onClose: toggleForm })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("div", null, [
            _createVNode(BaseTypography, {
              text: "Продолжительность:",
              type: "body2-m"
            }),
            _createVNode(BaseTypography, {
              text: excursion.value?.data?.attributes.duration,
              type: "body-m"
            }, null, 8, ["text"])
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("div", null, [
            _createVNode(BaseTypography, {
              text: "Место встречи:",
              type: "body2-m"
            }),
            _createVNode(BaseTypography, {
              text: excursion.value?.data?.attributes.meetLocation,
              type: "body-m"
            }, null, 8, ["text"])
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("div", null, [
            _createVNode(BaseTypography, {
              text: "Место окончания:",
              type: "body2-m"
            }),
            _createVNode(BaseTypography, {
              text: excursion.value?.data?.attributes.endLocation,
              type: "body-m"
            }, null, 8, ["text"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createVNode(BaseTypography, {
            text: "Описание",
            type: "subtitle-m"
          })
        ]),
        _createElementVNode("div", _hoisted_22, [
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_25))
            : (_openBlock(), _createBlock(MarkdownRenderer, {
                key: 1,
                markdown: excursion.value?.data.attributes?.description
              }, null, 8, ["markdown"]))
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_26, [
      _createElementVNode("div", _hoisted_27, [
        _createVNode(BaseTypography, {
          text: "Что включено",
          type: "subtitle-m"
        })
      ]),
      _createVNode(BaseAccordion, {
        title: "Экскурсионное обслуживание",
        class: "mb-[30px]",
        disabled: ""
      }),
      _createVNode(BaseAccordion, {
        title: "Входные билеты",
        disabled: ""
      })
    ]),
    _createElementVNode("section", _hoisted_28, [
      _createElementVNode("div", _hoisted_29, [
        _createVNode(BaseTypography, {
          text: "Часто задаваемые вопросы",
          type: "subtitle-m"
        })
      ]),
      _createVNode(BaseAccordion, {
        title: "Как забронировать и оплатить",
        class: "mb-[30px]"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_30, [
            _createVNode(BaseTypography, {
              text: "Шаг 1: отправить заявку",
              type: "body2-m",
              class: "mb-6"
            }),
            _createVNode(BaseTypography, {
              text: "Забронировать места на экскурсию вы можете следующим образом:",
              type: "body-m",
              class: "mb-6"
            }),
            _createVNode(BaseTypography, {
              text: "- нажать кнопку «ЗАБРОНИРОВАТЬ» в описании экскурсии;",
              type: "body-m"
            }),
            _createVNode(BaseTypography, {
              text: "- написать на почтовый адрес reserv@rvm-spb.ru;",
              type: "body-m"
            }),
            _createVNode(BaseTypography, {
              text: "- отправить запрос по электронной почте info@rvm-spb.ru.",
              type: "body-m",
              class: "mb-6"
            }),
            _createVNode(BaseTypography, {
              text: "Шаг 2: оплатить билеты",
              type: "body2-m",
              class: "mb-6"
            }),
            _createVNode(BaseTypography, {
              text: "У вас есть 2 способа сделать это:",
              type: "body-m",
              class: "mb-6"
            }),
            _createVNode(BaseTypography, {
              text: "1) Удалённо, через различные системы оплат (расчет с использованием реквизитов банковской карты, переводом через интернет-банк).",
              type: "body-m"
            }),
            _createVNode(BaseTypography, {
              text: "2) Подъехать заранее к нам в офис и оплатить наличными или по картам VISA, Mastercard, МИР. Наш офис в Бизнес центре 'Петровский форт', Финляндский проспект 4А, офис 201",
              type: "body-m",
              class: "mb-6"
            }),
            _createElementVNode("div", null, [
              _createVNode(BaseTypography, {
                text: "Внимание! ",
                type: "body2-m",
                tag: "span"
              }),
              _createVNode(BaseTypography, {
                text: "Заявка на тур подтверждается только специалистом компании.",
                type: "body-m",
                tag: "span"
              })
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(BaseAccordion, {
        title: "Способ оплаты",
        class: "mb-[30px]"
      }, {
        default: _withCtx(() => [
          _createElementVNode("ul", _hoisted_31, [
            _createElementVNode("li", null, [
              _createVNode(BaseTypography, {
                text: "Visa",
                type: "body-m"
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(BaseTypography, {
                text: "MasterCard",
                type: "body-m"
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(BaseTypography, {
                text: "Сбербанк",
                type: "body-m"
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(BaseTypography, {
                text: "ВТБ",
                type: "body-m"
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(BaseTypography, {
                text: "Тинькофф",
                type: "body-m"
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(BaseTypography, {
                text: "Наличными",
                type: "body-m"
              })
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(BaseAccordion, {
        title: "Сроки оплаты экскурсии",
        class: "mb-[30px]"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              _createVNode(BaseTypography, {
                text: "Бронирование экскурсии должно быть оплачено ",
                type: "body-m",
                tag: "span"
              }),
              _createVNode(BaseTypography, {
                text: "не позднее чем за 3 дня до ее проведения.",
                type: "body-m",
                tag: "span"
              })
            ]),
            _createElementVNode("div", null, [
              _createVNode(BaseTypography, {
                text: "! ",
                type: "body2-m",
                tag: "span"
              }),
              _createVNode(BaseTypography, {
                text: "Наш специалист отправит вам напоминание о крайнем сроке оплаты бронирования.",
                type: "body-m",
                tag: "span"
              })
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(BaseAccordion, {
        title: "Условия отмены бронирования",
        class: "mb-[30px]"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createVNode(BaseTypography, {
                text: "Отмена бронирования экскурсии осуществляется ",
                type: "body-m",
                tag: "span"
              }),
              _createVNode(BaseTypography, {
                text: "не позднее чем за 7 дня до ее проведения.",
                type: "body-m",
                tag: "span"
              })
            ]),
            _createElementVNode("div", null, [
              _createVNode(BaseTypography, {
                text: "! ",
                type: "body2-m",
                tag: "span"
              }),
              _createVNode(BaseTypography, {
                text: "Сроки аннуляций и штрафы по сборным экскурсиям определяются индивидуально и будут прописаны в договоре. Размер штрафа равняется фактически понесенным затратам. В случае частичной аннуляции услуг указанные штрафные санкции применяются к стоимости аннулированной части услуг.",
                type: "body-m",
                tag: "span"
              })
            ])
          ])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})